// extracted by mini-css-extract-plugin
module.exports = {"modal":"Modal_modal__2voHn","modalContent":"Modal_modalContent__3QS21"};